import React from "react";
import "../App.css";

function ImprintPage() {
  return (
    <div
      className="imprint-page"
      style={{
        padding: "4rem 2rem",
        maxWidth: "1000px",
        margin: "0 auto",
        lineHeight: "1.8",
      }}
    >
      <h1 style={{ marginBottom: "2rem" }}>Impressum</h1>
      <p>
        <strong>Onenizer GmbH</strong>
      </p>
      <p>Startup-Straße 1</p>
      <p>12345 Innovation City</p>
      <p>Deutschland</p>
      <br />
      <p>Email: info@onenizer.com</p>
      <p>Telefon: +49 (0)123 456 7890</p>
      <p>Website: www.onenizer.com</p>
    </div>
  );
}

export default ImprintPage;
